module.exports = __webpack_public_path__ + "img/blog-1-2.36ed0c56.webp";